import React from 'react'
import styled from 'styled-components'
import { useStoreState } from 'easy-peasy'
import media from '../../utils/media'
import Title from './Title'
import ImageTextFull from './ImageTextFull'
import FootNote from './FootNote'

const Container = styled.div`
  margin-bottom: ${props => props.marginBCont}px;
  position: relative;
  width: 100vw;
  max-width: 1440px;
  left: 50%;
  transform: translateX(-50%);
  .section-title {
    text-align: center;
    margin-bottom: 60px;
    ${media.mobileL`
      padding-top: 10px;
      margin-bottom: 30px;
    `}
  }
  ${media.mobileL`
    padding-right: 15px;
    padding-left: 15px;
    margin-bottom: calc(${props => props.marginBCont}px/2);
  `}
  ${media.laptopM`
    width: calc(100vw - 30px);
  `}
  .foot-note-text-img {
    ${media.mobileL`
      margin-top: 0;
      margin-bottom: 71px;
    `}
  }
`

export default function ImageTextContFull({ config }) {
  const {
    title,
    marginBTitle,
    marginBCont,
    items,
    titleFamily,
    fontFamily,
    footnote,
  } = config
  const [locale] = useStoreState(state => [state.locale.locale])
  const marginBot = locale === 'en-us' ? '120' : marginBCont

  return (
    <Container marginBCont={marginBot}>
      <Title title={title} marginBTitle={marginBTitle} />
      {items.map(el => {
        return (
          <ImageTextFull
            key={el.title}
            src={el.src}
            alt={el.alt}
            maxWidth={el.maxWidth}
            minWidth={el.minWidth}
            accent={el.accent}
            title={el.title}
            titleTwo={el.titleTwo}
            marginBText={el.marginBText}
            text={el.text}
            textTwo={el.textTwo}
            titleFamily={titleFamily}
            fontFamily={fontFamily}
          />
        )
      })}
      {footnote && (
        <FootNote
          footnote={footnote}
          className="foot-note-text-img"
        />
      )}
    </Container>
  )
}
